module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_6-067230ba1c60cf84d1f9d607164dbb78.jpg";